module.exports = __webpack_public_path__ + "img/icon_10.3ac9159a.png";